<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
    <b-card header-tag="header" style="font-weigth=fsbold">
      <template slot="header">
        <b-row>
          <b-col cols="12">
            <h3 class="float-left">
              <strong>Cardápio</strong>
            </h3>
            <b-button
              class="float-right mr-3"
              variant="success"
              @click="save"
              :disabled="!saveBtn"
              >Salvar</b-button
            >
            <b-button
              class="float-right mr-3"
              variant="danger"
              @click="inativar"
              :disabled="!inactive"
              >Inativar</b-button
            >
            <b-button
              class="float-right mr-3"
              variant="primary"
              @click="redirecionar"
              >Criar campanha</b-button
            >
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col xl="6" lg="6" md="6" sm="12">
          <b-card header="Imagem">
            <picture-input
              ref="pictureInput"
              margin="16"
              style="width: 80%; heigth: 80%"
              accept="image/*"
              :autoToggleAspectRatio="true"
              :removable="true"
              size="10"
              :zIndex="10"
              button-class="changeBtn"
              removeButtonClass="removeBtn"
              v-bind:prefill="prefill"
              :custom-strings="{
                upload:
                  '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                drag: 'Arraste uma imagem <br> (ou clique aqui)',
                change: 'Mudar foto',
                remove: 'Remover foto',
              }"
              @change="onChange"
            ></picture-input>
          </b-card>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12">
          <b-card header="Validade">
            <b-input-group prepend="Data" class="date-input mt-3 auto-prepend">
              <datepicker
                class="form-control"
                placeholder="Escolha a data"
                v-model="validade"
                :language="ptBR"
                :format="customFormatter"
                :disabled-dates="{ to: new Date(moment().subtract(1, 'days')) }"
                @input="onChangeDate"
              ></datepicker>
            </b-input-group>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import PictureInput from "vue-picture-input";
import axios from "axios";
import * as config from "@/config.json";
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import Loading from "vue-loading-overlay";

import moment from "moment";

export default {
  name: "Cardapio",
  components: {
    PictureInput,
    moment,
    Datepicker,
    Loading,
  },
  data: () => {
    return {
      saveBtn: false,
      imageSource: null,
      prefill: null,
      validade: null,
      ptBR: ptBR,
      isLoading: false,
      inactive: false,
    };
  },

  methods: {
    onChange(image) {
      if (image) {
        this.saveBtn = true;
        this.imageSource = image;

        this.verificaImagem(image);
      }
    },
    onChangeDate() {
      this.saveBtn = true;
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    goBack() {
      localStorage.removeItem("image");
      localStorage.removeItem("url_imagem");
      localStorage.removeItem("validade");
      this.$router.go(-1);
    },
    verificaImagem(imagem) {
      if (imagem != null) {
        this.inactive = true;
      } else {
        this.inactive = false;
      }
    },
    verificaCampos() {
      if (this.validade == null || this.validade == "") return false;
      return true;
    },
    async receberCardapio() {
      const url = `${
        config.default.servidor
      }/gerencial/cardapio/${localStorage.getItem("enterprise_id")}`;

      try {
        const response = await axios({
          url,
          methods: "get",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.prefill = response.data.url;
          this.validade = response.data.data;

          this.verificaImagem(this.prefill);
        }
      } catch (error) {
        this.$alert("Falha ao obter o cardápio!", "Error", "error");
        console.log({ error });
      }
    },
    redirecionar() {
      this.isLoading = true;
      localStorage.setItem("tipoid", "6");
      this.$router.push("/cadastrar-campanha");
      this.isLoading = false;
    },

    async inativar() {
      this.isLoading = true;

      const url = `${
        config.default.servidor
      }/gerencial/cardapio/inactive/company/${localStorage
        .getItem("enterprise_id")
        .toString()}`;

      try {
        const response = await axios({
          url,
          method: "put",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.isLoading = false;
          await this.$alert("Cardápio inativado!", "Sucesso", "success");
          document.location.reload(true);
        }
      } catch (error) {
        this.isLoading = false;
        this.$alert("Falha ao inativar o cardápioo!", "Erro", "error");
        console.log({ error });
      }
    },

    async save() {
      this.isLoading = true;

      if (this.verificaCampos()) {
        var data = moment(this.validade).format("YYYY-MM-DD");
        var dataCompleta = moment(`${data} 23:59:59`).format();
        const url = `${config.default.servidor}/gerencial/cardapio`;
        try {
          const response = await axios({
            url,
            method: "put",
            data: {
              empresaid: localStorage.getItem("enterprise_id").toString(),
              imagem: this.imageSource,
              datavalidade: dataCompleta,
            },
            headers: { authorization: config.default.authorizationBasic },
          });

          if (response.status == 200) {
            this.isLoading = false;
            this.saveBtn = false;
            this.$alert("Cardápio atualizado!", "Sucesso", "success");
          } else {
            this.isLoading = false;
            this.$alert("Erro ao atualizar o cardápio!", "Erro", "error");
          }
        } catch (error) {
          this.isLoading = false;
          this.$alert("Erro ao atualizar o cardápio!", "Erro", "error");
        }
      } else {
        this.isLoading = false;
        this.$alert(
          "Necessário informar uma data de validade para continuar!",
          "Aviso",
          "warning"
        );
      }
    },
  },

  async beforeMount() {
    this.isLoading = true;
    await this.receberCardapio();
    this.isLoading = false;
  },
};
</script>
